import React, { useEffect, useState } from "react";
import { defaultData } from "containers/Invoices/InvoiceObj";
import { generateInvoiceHTML2 } from "../../Invoices/InvoiceHTML";
import InvoicePdfModal from "../../Invoices/InvoicePdfModal";
import { connect } from "react-redux";
import * as actions from "store/actions";
import Loader from "../../../components/Loader/Loader";
import { calculateTotalInvoicePicture } from "../../Invoices/InvoiceLogic";

const InvoicePreview = props => {
    const [localPdfData, setLocalPdfData] = useState(null);
    const [openedPdfView, setOpenedPdfView] = useState(false);
    const [loading, setLoading] = useState(false);
    const [invo_data, set_invo_data] = useState(null);
    const { invoicePdf } = props;

    const getInvoData = async (rs_id, invoice_id, rsData) => {
        console.log('getting rs id', rs_id, invoice_id, rsData);
        const invd = await calculateTotalInvoicePicture(rs_id, rsData);
        set_invo_data(invd);
        const html = generateInvoiceHTML2(invd, invoice_id, rsData);
        props.getInvoicePdf({ htmlTemplate: html });
        setOpenedPdfView(true);
        setLoading(true);
    }

    useState(() => {
        if (props.data) {
            getInvoData(props.data.rs_id, props.data.id, props.data.data.rsData);
        }
    },[]);

    useEffect(() => {
        if (invoicePdf && typeof invoicePdf === "string") {
            const parsedPdf = JSON.parse(invoicePdf);
            setLocalPdfData(parsedPdf);
            setLoading(false);
        } else {
            setLocalPdfData(null);
        }
    }, [invoicePdf]);

    return <div>
        {localPdfData && openedPdfView && (
                <InvoicePdfModal
                    pdfData={localPdfData}
                    invoice={props.data}
                    open={true}
                    close={() => {
                        setLocalPdfData(null);
                        setLoading(false);
                        setOpenedPdfView(false);
                        props.close();
                    }}
                    hideDate={props.hideDate ? true : false}
                />
            )}
        {loading && <div><Loader /> Loading PDF...</div>}
    </div>
}

const mapStateToProps = (state) => {
    return {
        entriesData: state.invoice.entriesData,
        error: state.invoice.error,
        success: state.invoice.success,
        loading: state.invoice.loading,
        invoicePdf: state.invoice.invoicePdf,
        rsheetData: state.rs.rsheetData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getInvoiceEntries: (status) => {
            dispatch(actions.getInvoiceEntries(status));
        },
        createInvoiceEntry: (data) => {
            dispatch(actions.createInvoiceEntry(data));
        },
        updateInvoiceEntry: (data) => {
            dispatch(actions.updateInvoiceEntry(data));
        },
        deleteInvoiceEntry: (id) => {
            dispatch(actions.deleteInvoiceEntry(id));
        },
        getInvoicePdf: (html) => {
            dispatch(actions.getInvoicePdf(html));
        },
        clearInvoicePdfData: () => {
            dispatch(actions.clearInvoicePdfData());
        },
        resendInvoiceEmail: (data) => {
            dispatch(actions.resendInvoiceEmail(data))
        },
        getRsheet: (id) => dispatch(actions.getRsheet(id)),
        resetRsData: () => dispatch(actions.getRsheetStart()),
        resetInvoiceID: () => dispatch(actions.resetInvoiceID()),
        clearRSheets: () => dispatch(actions.clearRSheets()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicePreview);